/**
 * Transparent header controller — coordinates store-header transparency with
 * first-section [allow-transparent-header] and optional homepage opaque-after-load.
 */
(function () {
  var revealed = false;
  var transparencyPatched = false;

  function hasTransparentFirstSection() {
    return !!document.querySelector('.shopify-section:first-child [allow-transparent-header]');
  }

  function patchStoreHeaderTransparency() {
    if (transparencyPatched) return;
    var HeaderCtor = customElements.get('store-header');
    if (!HeaderCtor || !HeaderCtor.prototype._checkTransparency) return;
    transparencyPatched = true;
    var original = HeaderCtor.prototype._checkTransparency;
    HeaderCtor.prototype._checkTransparency = function () {
      if (
        document.documentElement.classList.contains('homepage-header-awaiting-load') &&
        !this.classList.contains('homepage-header--loaded')
      ) {
        this.classList.remove('is-filled');
        return;
      }
      if (
        this.hasAttribute('homepage-opaque-revealed') &&
        this.querySelectorAll('[open]').length === 0
      ) {
        this.classList.add('is-filled');
        return;
      }
      return original.call(this);
    };
  }

  function syncTransparentHeader(header, controller) {
    if (!header || controller.hasAttribute('disabled')) return;

    var homepageAwait = controller.hasAttribute('homepage-opaque-after-load');
    var awaitingHomepage = homepageAwait && !header.classList.contains('homepage-header--loaded');

    if (awaitingHomepage) {
      document.documentElement.classList.add('homepage-header-awaiting-load');
      header.classList.remove('is-filled');
    }

    if (hasTransparentFirstSection() || awaitingHomepage) {
      header.setAttribute('allow-transparency', '');
      if (typeof header._setupTransparentHeader === 'function') {
        header._setupTransparentHeader();
      }
      document.documentElement.classList.toggle(
        'transparent-header-active',
        hasTransparentFirstSection() && !awaitingHomepage
      );
    } else if (!homepageAwait) {
      header.removeAttribute('allow-transparency');
      document.documentElement.classList.remove('transparent-header-active');
    }

    patchStoreHeaderTransparency();
  }

  function revealHomepageHeader(header, controller) {
    if (revealed || !controller.hasAttribute('homepage-opaque-after-load')) return;
    revealed = true;

    document.documentElement.classList.remove('homepage-header-awaiting-load');
    document.documentElement.classList.add('homepage-header-loaded');
    document.documentElement.classList.remove('transparent-header-active');

    header.classList.add('homepage-header--loaded', 'is-filled');
    header.setAttribute('homepage-opaque-revealed', '');

    if (hasTransparentFirstSection()) {
      header.setAttribute('allow-transparency', '');
    }

    patchStoreHeaderTransparency();
    controller.dispatchEvent(new CustomEvent('transparent-header:revealed', { bubbles: true }));
  }

  function setupHomepageOpaqueAfterLoad(header, controller) {
    if (!controller.hasAttribute('homepage-opaque-after-load')) return;

    document.documentElement.classList.add('homepage-header-awaiting-load');
    header.classList.remove('is-filled');

    var minWait = parseInt(controller.getAttribute('data-homepage-min-wait') || '0', 10);
    var fallbackMs = parseInt(controller.getAttribute('data-homepage-load-fallback') || '8000', 10);
    var startedAt = Date.now();

    function scheduleReveal() {
      var delay = Math.max(0, minWait - (Date.now() - startedAt));
      window.setTimeout(function () {
        revealHomepageHeader(header, controller);
        syncTransparentHeader(header, controller);
      }, delay);
    }

    if (document.readyState === 'complete') {
      scheduleReveal();
    } else {
      window.addEventListener('load', scheduleReveal, { once: true });
    }

    window.setTimeout(function () {
      if (!revealed) scheduleReveal();
    }, fallbackMs);
  }

  class TransparentHeaderController extends HTMLElement {
    connectedCallback() {
      if (this.hasAttribute('disabled')) return;

      var controller = this;

      customElements.whenDefined('store-header').then(function () {
        var header = controller.closest('.shopify-section--header')?.querySelector('store-header');
        if (!header) return;

        syncTransparentHeader(header, controller);
        setupHomepageOpaqueAfterLoad(header, controller);

        if (Shopify && Shopify.designMode) {
          document.addEventListener('shopify:section:load', function () {
            syncTransparentHeader(header, controller);
          });
          document.addEventListener('shopify:section:unload', function () {
            syncTransparentHeader(header, controller);
          });
          document.addEventListener('shopify:section:reorder', function () {
            syncTransparentHeader(header, controller);
          });
        }

        var observer = new MutationObserver(function () {
          syncTransparentHeader(header, controller);
        });
        var main = document.getElementById('main');
        if (main) {
          observer.observe(main, { childList: true, subtree: false });
        }
      });
    }
  }

  if (!window.customElements.get('transparent-header-controller')) {
    window.customElements.define('transparent-header-controller', TransparentHeaderController);
  }
})();
